const state = {

};

const getters = {
};

const mutations = {

};

const actions = {
  async createPinHandler({dispatch}, data) {
    let res = await dispatch('api/nav/createPin', data)
    await dispatch('analytics/pinUser', data)

    if (!res.success) {
      dispatch('showErrorCreatingPinPopup')
    }

    return res
  },
  async cancelPinHandler({dispatch}, data) {
    let res = await dispatch('api/nav/cancelPin', data)
    await dispatch('analytics/cancelPinUser', data)

    if (!res.success) {
      dispatch('popups/nav/errorCancellingPin')
    }

    return res
  },
  async handlePinHandler({dispatch}, data) {
    let res = await dispatch('api/nav/handlePin', data)

    if (!res.success) {
      dispatch('popups/nav/errorCancellingPin')
    }

    return res
  },
  async invitePinnedUserHandler({getters,commit,dispatch}, data) {
    let isPinnedUserInDifferentSpace = data?.data?.pinnedUserAreaId !== getters.getCurrentAreaId
    const callback = async () => {
      await dispatch('inviteUserToSpaceHandler', [{
        userId: data.data.pinnedUserId
      }, isPinnedUserInDifferentSpace, true])
    }

    //to mark you have invited them
    dispatch('handlePinHandler', [data.data.pinsId])

    if(data.locationId !== getters.getCurrentAreaId) {
      commit('routing/CHANGE_CALLBACK', {routeName: 'area', callback })
      dispatch('routing/goToArea', data.locationId)
    } else callback()
  },
};

export default {
state,
getters,
mutations,
actions
};
